// returns a binder for select element
export default function select(multiple) {
  if (multiple) {
    return {
      on: 'change',
      getValue: function getValue() {
        var options = this.options;
        var result = [];
        for (var i = 0; options.length > i; i++) {
          if (options[i].selected) {
            result.push(options[i].value);
          }
        }
        return result;
      },
      setValue: function setValue(givenValue) {
        var options = this.options;
        var values = [];
        if (Array.isArray(givenValue)) {
          values = givenValue;
        } else if (givenValue !== null && givenValue !== undefined) {
          values = [givenValue];
        }
        // option values are strings, so [1] selects the option "1" as the single select does
        values = values.map(String);
        for (var i = options.length - 1; i >= 0; i--) {
          options[i].selected = values.indexOf(options[i].value) !== -1;
        }
      }
    };
  }
  return {
    on: 'change',
    getValue: function getValue() {
      return this.value;
    },
    setValue: function setValue(value) {
      this.value = value;
      // an empty value selects the option without value; 0 is a value
      if (!value && value !== 0) {
        var options = this.options;
        for (var i = options.length - 1; i >= 0; i--) {
          if (!options[i].value) {
            options[i].selected = true;
            break;
          }
        }
      }
    }
  };
}